import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddCoupon from './AddCoupon';

const CouponList = () => {
  const [coupons, setCoupons] = useState([]);

  const fetchCoupons = async () => {
    try {
      const res = await axios.get('https://sonvika.hxbindia.com/api/coupons');
      setCoupons(res.data);
      console.log(res.data)
    } catch (error) {
      console.error('Failed to fetch coupons:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this coupon?")) return;
    try {
      await axios.delete(`https://sonvika.hxbindia.com/api/coupons/${id}`);
      fetchCoupons();
    } catch (error) {
      console.error('Error deleting coupon:', error);
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  return (
    <div className="container mt-4">
      <AddCoupon onCouponAdded={fetchCoupons} />
      <h4>All Coupons</h4>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Code</th>
            <th>Type</th>
            <th>Amount</th>
            <th>Min Order</th>
            <th>Expires</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {coupons.map(coupon => (
            <tr key={coupon._id}>
              <td>{coupon.code}</td>
              <td>{coupon.discountType}</td>
              <td>{coupon.discountAmount}</td>
              <td>{coupon.minOrderAmount}</td>
              <td>{new Date(coupon.expiresAt).toLocaleDateString()}</td>

              <td>
                {!coupon.isActive && <span className="badge bg-danger">Inactive</span>}
{new Date(coupon.expiresAt) < new Date() && <span className="badge bg-warning">Expired</span>}

              </td>
              <td>
                <button onClick={() => handleDelete(coupon._id)} className="btn btn-danger btn-sm">
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CouponList;
